module.exports = __webpack_public_path__ + "media/images/v2/HeaderBackground-5865b7eba4fe4235c6ae155fdb1a92f0.jpg";